import * as React from 'react'

import compact from 'lodash/compact'

import PaywallModal from 'modules/core/components/PaywallModal'

interface Props {
  disableClick?: boolean
  disabled?: boolean
  className?: string
  onClick?: React.MouseEventHandler<HTMLElement>
  onDrop?: React.DragEventHandler<HTMLElement>
}

/**
 *
 * You might not want to use this directly, but via the `Authorized`, `ExpiredTrialChecker`
 * or `ExpiredTrialActionChecker` components.
 */
export function AuthorizeAction({
  disableClick,
  disabled,
  onDrop,
  ...props
}: React.PropsWithChildren<Props>) {
  const [isOpen, setIsOpen] = React.useState(false)

  function handleClickEvent(event: React.MouseEvent) {
    event.stopPropagation()
    event.nativeEvent.stopImmediatePropagation()

    if (!disableClick) setIsOpen(true)
  }

  function handleDropEvent(event: React.DragEvent) {
    event.preventDefault()

    if (onDrop) setIsOpen(true)
  }

  const children = compact(React.Children.toArray(props.children))

  return (
    <div
      className={props.className}
      onClick={handleClickEvent}
      onDrop={handleDropEvent}
      onDragOver={(event) => event.preventDefault()}
    >
      {React.Children.map(children, (element) =>
        React.cloneElement(element as JSX.Element, {
          disabled,
        })
      )}
      {isOpen && <PaywallModal {...props} onClose={() => setIsOpen(false)} />}
    </div>
  )
}
